import { connect } from 'react-redux';
import type { AppState } from 'state/state.model';
import * as TradeAllocationSelectors from 'state/tradeAllocationForm/tradeAllocationForm.selector';

interface OwnProps {
  tabId: string;
}

interface StateProps {
  isLoading: boolean;
  isReadyToApplyTradeAllocations: boolean;
}

export type InitializedStatusProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  return {
    isLoading: TradeAllocationSelectors.isLoading(state, tabId),
    isReadyToApplyTradeAllocations: TradeAllocationSelectors.isReadyToApplyTradeAllocations(state, tabId),
  };
};

export const connectInitializedStatus = connect(mapStateToProps);
